import { render } from "./ForgotPasswordInstructionsPage.vue?vue&type=template&id=22da37de&ts=true"
import script from "./ForgotPasswordInstructionsPage.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordInstructionsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__